<template>
  <div :class="['order', {authorized: isAuthorized}]">
    <a class="order__title" :href="`/orders/${orderTitle}/`">
      Заказ № {{ orderTitle }}
    </a>
    <div class="order__info">
      <span class="order__date">
        Дата доставки: {{ orderDate }}
      </span>
      <span class="order__status">
        Статус: {{ orderStatus }}
      </span>
    </div>
    <button
      v-if="!isAuthorized"
      class="_btn _btn--transparent order__button"
      @click="clickHandler"
    >
      <span />
      <p>Отправить статус на почту</p>
    </button>
    <p
      v-if="sendStatus && sendStatus.isShow"
      :class="['send-message__status', sendStatus.isSuccess ? '_success' : '_error']"
      v-html="sendStatus.text"
    />
  </div>
</template>

<script>

export default {
  name: 'order-block',

  props: {
    isAuthorized: {
      type: Boolean,
      default: false,
    },
    orderTitle: {
      type: String,
      default: '',
    },
    orderDate: {
      type: String,
      default: '',
    },
    orderStatus: {
      type: String,
      default: '',
    },
    sendStatus: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    async clickHandler() {
      this.$emit('sendOnMail', { orderNumber: this.orderTitle });
    },
  },
};
</script>

<style lang="scss" scoped>
.order {
  width: 100%;
  color: #333332;

  &__title {
    font-size: 19px;
    line-height: 23px;
    font-weight: 500;
    letter-spacing: 0.03em;
    transition: color .3s;

    &:hover {
      color: #E30613;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    margin-top: 6px;
    font-size: 15px;
    line-height: 19.5px;
    font-weight: 400;
    letter-spacing: 0.04em;
    color: #333332;
  }

  &__button {
    max-width: none;
    margin-top: 15px;
  }

  &.authorized {
    .order__info {
      flex-direction: column;
      column-gap: 0;
      row-gap: 4px;
    }
  }

  & .send-message__status {
    margin-top: 14px;
    font-size: 14px;
    line-height: 14px;

    &._success {
      color: green
    }

    &._error {
      color: red
    }
  }
}
</style>
